<template>
    <div>
        <HijriDatePicker v-model="selectedDate"
                         :typeDate="selectedOption"
                         :min="minDate"
                         :max="maxDate"
                         outlined
                         :label="$t('HijriDate')" />
    </div>
</template>
<!--@input="handleDateChange"-->
<script>
    import moment from 'moment-hijri'
    import HijriDatePicker from '@/components/controls/Hijri.vue'

    export default {
        components: {
            HijriDatePicker
        },
        props: {
            value: {
                type: String,
                default: ''
            },
            optionValue: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                selectedDate: null,
                selectedYearMonth: null,
                fromTo: '&',
                minDate: '',
                maxDate: '',
                rules: [
                    value => !!value || this.$t('DateRequired'),
                ],
                customStyles: 'calendar-custom',
                selectedOption: '' // Initialize selectedOption
            }
        },
        watch: {
            optionValue: {
                immediate: true,
                handler(newValue) {
                    if (!newValue) return
                    
                    const [option, values] = newValue.split('#')
                    this.selectedOption = option
                    
                    if (values) {
                        this.handleMinMax(values)
                    }
                }
            },

            selectedDate(newDate) {
                moment.locale('en-us')
                if (this.selectedOption === 'year') {

                    this.$emit('input', moment(new Date((Number(newDate) + 1).toString())).format('iYYYY'))
                } else if (this.selectedOption === 'month') {
                    this.$emit('input', newDate)

                } else if (this.selectedOption === 'date') {
                    this.$emit('input', moment(new Date(newDate)).format('iYYYY-iMM-iDD'))

                }

            }
        },
        methods: {
            handleMinMax(values) {
                const [from, to] = values.split('$')
                
                if (this.selectedOption === 'year') {
                    if (from && to) {
                        moment.locale('en-us')
                        this.minDate = moment(from, 'iYYYY').format('YYYY')
                        moment.locale('en-us')
                        this.maxDate = moment(to, 'iYYYY').format('YYYY')
                    }
                    else if (!from && to) {
                        this.minDate = null
                        moment.locale('en-us')
                        this.maxDate = moment(to, 'iYYYY').format('YYYY')

                    } else if (from && !to) {
                        moment.locale('en-us')
                        this.minDate = moment(from, 'iYYYY').format('YYYY')
                        this.maxDate = null
                    } else {
                        this.minDate = null
                        this.maxDate = null
                    }
                } else if (this.selectedOption === 'month') {
                    if (from && to) {
                        moment.locale('en-us')
                        this.minDate = moment(from, 'iYYYY-iMM').format('YYYY-MM')
                        moment.locale('en-us')
                        this.maxDate = moment(to, 'iYYYY-iMM').format('YYYY-MM')
                    }
                    else if (!from && to) {
                        this.minDate = null
                        moment.locale('en-us')
                        this.maxDate = moment(to, 'iYYYY-iMM').format('YYYY-MM')

                    } else if (from && !to) {
                        moment.locale('en-us')
                        this.minDate = moment(from, 'iYYYY-iMM').format('YYYY-MM')
                        this.maxDate = null
                    } else {
                        this.minDate = null
                        this.maxDate = null
                    }
                } else if (this.selectedOption === 'date') {

                    if (from && to) {
                        moment.locale('en-us')
                        this.minDate = moment(from, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')
                        moment.locale('en-us')
                        this.maxDate = moment(to, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')
                    }
                    else if (!from && to) {
                        this.minDate = null
                        moment.locale('en-us')
                        this.maxDate = moment(to, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')

                    } else if (from && !to) {
                        moment.locale('en-us')
                        this.minDate = moment(from, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')
                        this.maxDate = null
                    } else {
                        this.minDate = null
                        this.maxDate = null
                    }

                }
            },
            handleDateChange() {
                moment.locale('en-us')
                if (this.selectedOption == 'year') {
                    
                    this.$emit('input', moment(this.selectedDate, 'YYYY').format('iYYYY'))
                } else if (this.selectedOption == 'month') {
                    this.$emit('input', moment(this.selectedDate, 'YYYY-MM').format('iYYYY-iMM'))

                } else if (this.selectedOption == 'date') {

                    this.$emit('input', moment(this.selectedDate, 'YYYY-MM-DD').format('iYYYY-iMM-iDD'))
                }

            },
            convertFromArabicNumerals(number) {
                const easternArabicNumerals = '٠١٢٣٤٥٦٧٨٩'
                const westernArabicNumerals = '0123456789'

                return number.toString().replace(/[٠١٢٣٤٥٦٧٨٩]/g, (digit) => {
                    return westernArabicNumerals[easternArabicNumerals.indexOf(digit)]
                })
            }
        },
        created() {
            this.$nextTick(() => {
                if (this.value) {
                    const [option, values] = this.value.split('#')
                    this.selectedOption = option//.charAt(0).toUpperCase() + option.slice(1)

                    if (values) {
                        const [from, to] = values.split('$')
                        if (option === 'year') {
                            if (from && to) {
                                moment.locale('en-us')
                                this.minDate = moment(from, 'iYYYY').format('YYYY')
                                moment.locale('en-us')
                                this.maxDate = moment(to, 'iYYYY').format('YYYY')
                            }
                            else if (!from && to) {
                                this.minDate = null
                                moment.locale('en-us')
                                this.maxDate = moment(to, 'iYYYY').format('YYYY')

                            } else if (from && !to) {
                                moment.locale('en-us')
                                this.minDate = moment(from, 'iYYYY').format('YYYY')
                                this.maxDate = null
                            } else {
                                this.minDate = null
                                this.maxDate = null
                            }
                        } else if (option === 'month') {
                            if (from && to) {
                                moment.locale('en-us')
                                this.minDate = moment(from, 'iYYYY-iMM').format('YYYY-MM')
                                moment.locale('en-us')
                                this.maxDate = moment(to, 'iYYYY-iMM').format('YYYY-MM')
                            }
                            else if (!from && to) {
                                this.minDate = null
                                moment.locale('en-us')
                                this.maxDate = moment(to, 'iYYYY-iMM').format('YYYY-MM')

                            } else if (from && !to) {
                                moment.locale('en-us')
                                this.minDate = moment(from, 'iYYYY-iMM').format('YYYY-MM')
                                this.maxDate = null
                            } else {
                                this.minDate = null
                                this.maxDate = null
                            }
                        } else if (option === 'date') {

                            if (from && to) {
                                moment.locale('en-us')
                                this.minDate = moment(from, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')
                                moment.locale('en-us')
                                this.maxDate = moment(to, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')
                            }
                            else if (!from && to) {
                                this.minDate = null
                                moment.locale('en-us')
                                this.maxDate = moment(to, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')

                            } else if (from && !to) {
                                moment.locale('en-us')
                                this.minDate = moment(from, 'iYYYY-iMM-iDD').format('YYYY-MM-DD')
                                this.maxDate = null
                            } else {
                                this.minDate = null
                                this.maxDate = null
                            }

                        }
                    }
                }
            })
        }
    }
</script>

<style>
    .calendar-custom {
        font-size: 14px;
        color: #333;
    }
</style>
